<template>
  <v-menu
    v-model="menu"
    offset-y
    transition="slide-y-transition"
    :close-on-content-click="false"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        v-on="on"
        v-bind="attrs"
        icon
        :loading="loading"
      >
        <v-icon v-text="icons.calendar" />
      </v-btn>
    </template>
    <v-date-picker
      light
      no-title
      color="primary"
      first-day-of-week="1"
      :value="picked"
      :min="datePickerMin"
      :max="datePickerMax"
      @input="pick"
    />
  </v-menu>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    mixins: [
      UsesIcons,
    ],

    data: () => ({
      menu: false,
    }),

    computed: {
      ...mapState('history', [
        'loading',
        'date',
        'datePickerMin',
        'datePickerMax',
      ]),
      picked () {
        return this.date?.format('YYYY-MM-DD')
      },
    },

    methods: {
      ...mapActions('history', [
        'changeDate',
      ]),
      pick (date) {
        this.menu = false
        this.changeDate(date)
      },
    },
  }
</script>
